var costCenterData = [
    {
        'RPT_COST_CENTER_SALES_ID': 8327705.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1730605.0,
        'COST_CENTER_NAME': 'BAR',
        'SALES_AMT': 2306.21,
        'SALES_CNT': 87.0,
        'SALES_PCT': 26.21,
        'GUEST_CNT': 87.0,
        'COVER_CNT': 0.0,
        'LOAD_TIME': '2020-04-15T19:25:00',
        'BUSINESS_DATE': '2020-04-15T00:00:00'
    },
    {
        'RPT_COST_CENTER_SALES_ID': 8327706.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1730605.0,
        'COST_CENTER_NAME': 'FUNCTION ROOM',
        'SALES_AMT': 0.0,
        'SALES_CNT': 0.0,
        'SALES_PCT': 0.0,
        'GUEST_CNT': 0.0,
        'COVER_CNT': 0.0,
        'LOAD_TIME': '2020-04-15T19:25:00',
        'BUSINESS_DATE': '2020-04-15T00:00:00'
    },
    {
        'RPT_COST_CENTER_SALES_ID': 8327707.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1730605.0,
        'COST_CENTER_NAME': 'CATERING IN',
        'SALES_AMT': 0.0,
        'SALES_CNT': 0.0,
        'SALES_PCT': 0.0,
        'GUEST_CNT': 0.0,
        'COVER_CNT': 0.0,
        'LOAD_TIME': '2020-04-15T19:25:00',
        'BUSINESS_DATE': '2020-04-15T00:00:00'
    },
    {
        'RPT_COST_CENTER_SALES_ID': 8327708.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1730605.0,
        'COST_CENTER_NAME': 'FRONT ROOM',
        'SALES_AMT': 1666.83,
        'SALES_CNT': 43.0,
        'SALES_PCT': 18.94,
        'GUEST_CNT': 76.0,
        'COVER_CNT': 0.0,
        'LOAD_TIME': '2020-04-15T19:25:00',
        'BUSINESS_DATE': '2020-04-15T00:00:00'
    },
    {
        'RPT_COST_CENTER_SALES_ID': 8327709.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1730605.0,
        'COST_CENTER_NAME': 'TO GO',
        'SALES_AMT': 733.17,
        'SALES_CNT': 36.0,
        'SALES_PCT': 8.33,
        'GUEST_CNT': 36.0,
        'COVER_CNT': 0.0,
        'LOAD_TIME': '2020-04-15T19:25:00',
        'BUSINESS_DATE': '2020-04-15T00:00:00'
    },
    {
        'RPT_COST_CENTER_SALES_ID': 8327710.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1730605.0,
        'COST_CENTER_NAME': 'BACK ROOM',
        'SALES_AMT': 2042.95,
        'SALES_CNT': 32.0,
        'SALES_PCT': 23.22,
        'GUEST_CNT': 99.0,
        'COVER_CNT': 0.0,
        'LOAD_TIME': '2020-04-15T19:25:00',
        'BUSINESS_DATE': '2020-04-15T00:00:00'
    },
    {
        'RPT_COST_CENTER_SALES_ID': 8327711.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1730605.0,
        'COST_CENTER_NAME': 'LOUNGE',
        'SALES_AMT': 2049.55,
        'SALES_CNT': 49.0,
        'SALES_PCT': 23.29,
        'GUEST_CNT': 95.0,
        'COVER_CNT': 0.0,
        'LOAD_TIME': '2020-04-15T19:25:00',
        'BUSINESS_DATE': '2020-04-15T00:00:00'
    },
    {
        'RPT_COST_CENTER_SALES_ID': 8327712.0,
        'HIERARCHY_ID': 757.0,
        'TIME_DIM_ID': 1730605.0,
        'COST_CENTER_NAME': 'TRAINING',
        'SALES_AMT': 0.0,
        'SALES_CNT': 0.0,
        'SALES_PCT': 0.0,
        'GUEST_CNT': 0.0,
        'COVER_CNT': 0.0,
        'LOAD_TIME': '2020-04-15T19:25:00',
        'BUSINESS_DATE': '2020-04-15T00:00:00'
    }
]

export default costCenterData